import React, { Component } from "react";
import { Input, Form, Alert } from 'antd';
import './index.less';
export default class InputContainer extends Component {
  render() {
    const {
      data,
      sceneCode
    } = this.props;
    const {
      getFieldDecorator,
      getFieldValue
    } = this.props.form;
    const conInput = getFieldDecorator(JSON.stringify(data.fieldId), {
      rules: [{
        required: data.required,
        validator: (rule, value, callback) => {
          let val = value || "";

          if (data.required && val === "") {
            callback('必填项，请输入相关信息');
            return;
          }

          if (data.length && val.length > data.length) {
            callback(`输入长度不超过${data.length}`);
            return;
          }

          callback();
        }
      }],
      initialValue: data.value || ''
    })(<Input data-inspector-line="27" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\InputContainer\\index.jsx" placeholder={sceneCode == '1' && data.fieldTip ? data.fieldTip : '请输入'} maxLength={data.length || null} onChange={this.handleChange} disabled={data.frontUpdateFlag === 1} />);
    return <div data-inspector-line="30" data-inspector-column="6" data-inspector-relative-path="src\\components\\CreateFormItem\\InputContainer\\index.jsx" className="detail-sel-input detail-sel-wrap">
        <Form.Item data-inspector-line="31" data-inspector-column="8" data-inspector-relative-path="src\\components\\CreateFormItem\\InputContainer\\index.jsx">
          {conInput}
          {data.length && <span data-inspector-line="33" data-inspector-column="26" data-inspector-relative-path="src\\components\\CreateFormItem\\InputContainer\\index.jsx" className="num-span">{`${getFieldValue(JSON.stringify(data.fieldId)).length} / ${data.length}`}</span> || null}
        </Form.Item>
      </div>;
  }

}